<script setup lang="ts">
import type { Language } from "../../types/navbar";

defineProps<{ languages: Language[] }>();
</script>

<template>
  <LayoutDropdown class="language-drop-down">
    <LayoutLegacyLanguageSwitcher :languages="languages" />
  </LayoutDropdown>
</template>
